export default __webpack_public_path__ + "static/media/power.dc884d49.png";